





















































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import PathTipPanel from '@/components/common/gis/pathplan/PathTipPanel.vue';
import PathAlsTabCommonItem from '@/views/pathPlan/PathAlsTabCommonItem.vue';
import PathAlsTabBusCityOutItem from '@/views/pathPlan/PathAlsTabBusCityOutItem.vue';
import PathAlsTabBusCityInItem from '@/views/pathPlan/PathAlsTabBusCityInItem.vue';
import PathErrorPanel from '@/views/pathPlan/PathErrorPanel.vue';
import MapResolver from '../../util/MapResolver';
@Component({
    name: 'LayoutPathPlan',
    components : {
        PathTipPanel,
        PathAlsTabCommonItem,
        PathAlsTabBusCityOutItem,
        PathAlsTabBusCityInItem,
        PathErrorPanel,
    },
    mixins: [MapResolver],
})
export default class LayoutPathPlan extends Vue {
    @Injectable() public container!: Container;
    private isShowPathTip: any = false; // 控制关键词提示面板显隐
    private isShowPathAlsTabBusItem: any = false; // 控制公交路径信息面板的显隐
    private keywordTipListDatas: any = []; // 关键词提示面板的列表数据
    private loadingState = false; // 查询状态
    private  errPanel: any = false; // 是否展示查无路线面板
    // 交通工具tab区域
    private typeIndex: any = 'bus';
    private typeTabList: any = {
        bus: {
            title: '公交',
            value: 'bus',
            getPathDataFun: 'getData_bus',
            doWithResultPathDataFun: 'doWithPathResultData_bus',
            strategy_incity: [// 同城
                {
                    title: '推荐',
                    value: 0,
                },
                {
                    title: '少换乘',
                    value: 1,
                },
                {
                    title: '少步行',
                    value: 2,
                },
                {
                    title: '不坐地铁',
                    value: 3,
                },
                {
                    title: '时间短',
                    value: 4,
                },
                {
                    title: '地铁优先',
                    value: 5,
                },
            ],
            strategy_intercity: [// 跨城
                {
                    title: '推荐',
                    value: 0,
                },
                {
                    title: '出发早',
                    value: 1,
                },
                {
                    title: '价格低',
                    value: 2,
                },
            ],
            Trans_type_intercity: [// 	跨城交通方式策略
                {
                    title: '火车优先',
                    value: 0,
                },
                {
                    title: '飞机优先',
                    value: 1,
                },
                {
                    title: '大巴优先',
                    value: 2,
                },
            ],
        },
        driving: {
            title: '驾车',
            value: 'driving',
            getPathDataFun: 'getData_driving', // 获得路径数据（点击按钮时调用的方法名）
            doWithResultPathDataFun: 'doWithPathResultData', // 对getPathDataFun返回数据处理的方法名
            tabList: [
                {
                    title: '常规路线',
                    value: 0,
                },
                {
                    title: '最短路径',
                    value: 3,
                },
                {
                    title: '不走高速',
                    value: 1,
                },
            ],
        },
        riding: {
            title: '骑行',
            value: 'riding',
            getPathDataFun: 'getData_riding',
            doWithResultPathDataFun: 'doWithPathResultData',
            tabList: [
                {
                    title: '普通自行车',
                    value: 0,
                },
                {
                    title: '电动自行车',
                    value: 1,
                },
            ],
        },
        walking: {
            title: '步行',
            value: 'walking',
            getPathDataFun: 'getData_walking',
            doWithResultPathDataFun: 'doWithPathResultData',
        },
    };
    // 公交专用数据
    private curBusObjData: any = {
        isCityCross: true, // 是否同城,true 同城
        tabList: this.typeTabList.bus.strategy_incity,
        parentTabList: [],
        curTabItem: this.typeTabList.bus.strategy_incity[0],
        curParentTabItem: this.typeTabList.bus.Trans_type_intercity[0],
        curSamePathObj: {// 同城
            pathResult: [], // 列表数据
            curPathIndex: -1, // 当前点开的详情的数组下标索引,
            curPathIndexForHover: 0, // 因为详情有展开收起状态，但是hover需要一直保持，所以特意写一个标志位，操作当前方案的急活状态。和地图的路线一致
        },
        curCrossPathObj: {
            pathResult: [], // 列表数据
            curPathIndex: 0, // 当前点开的路径方案总览的路线数组下标索引
            curStepIndex: -1, // 当前方案下的第几个step，和curPathIndex结合用来展示详情

        },
    };
    // 起点、终点输入区域
    private pathMainDatas: any = [
        {
            iconClass: 'preIcon startIcon',
            clickClass: 'el-icon-circle-plus',
            placeholder: '请输入起点或在地图上选点',
            inputKey: '',
            isClickOptions: false,
        },
        {
            iconClass: 'preIcon endIcon',
            clickClass: '',
            placeholder: '请输入终点或在地图上选点',
            inputKey: '',
            isClickOptions: false,
        },
    ];
    private currentIndex: any = -1;
    private addPathNodeNum: any = 0;
    private sendPathNodeInfo: any = [];
    private tabIndex: any = 0;
    private tabList: any = [
        {
            title: '常规路线',
            value: 0,
        },
        {
            title: '最短路径',
            value: 3,
        },
        {
            title: '不走高速',
            value: 1,
        },

    ];
    private tabShowFlag: any = true;
    private addButtonFlag: any = true;

    private timeout: any = null;


    private resultLength: any  = 0;
    private pathanalysislist: any  = [];
    // 保存途径点的变量
    private tempDrivingDatas: any = [];
    constructor() {
        super();
    }

    /**
     * poi建议搜索列表
     */
    public async getListPOI(keywords: string) {
        try {
            this.isShowPathTip = true;
            const component: any = await this.getComponent('Toolbar', 'RegeoCode');
            const searchComp: any = await this.getComponent('Search', 'POISearch');
            component.regeocode().then((result: any) => {
                searchComp.keywordSearch(keywords, 2, result).then((suggest: any) => {
                    this.keywordTipListDatas = suggest;
                });
            });
        } catch (err) {
            console.log('建议词查询列表接口请求失败', err);
        }
    }



    public async mounted() {
        // const targetId: any = "map";
        // const mapShare: any = await this.initMap(targetId);
        //
        // // 地图加载完成，全局通知
        // const notify = this.container.resolve("notify");
        // notify.emit(`map-ready-${targetId}`, mapShare);
    }

    // -----------路径规划面板关闭---------------
     private async pathCloseClick() {

        this.isShowPathTip = false;
        const component: any = await this.getComponent();
        component.unload();
        this.$emit('closePathPanelEmit');

    }
    /* 交通工具tab区域*/
    // ----------路径规划类型tab切换事件----------------
    private async toTypeTabItemClick(item: any) {
        this.isShowPathAlsTabBusItem = false;
        if (this.typeIndex === item.value) {
            return;
        }

        this.typeIndex = item.value;
        this.onChange(this.typeIndex);
        this.toSearchPath(true);
        const component: any = await this.getComponent();
        component.resumeMidPoints();

    }

    // typeIndex 改变，即选项卡切换成功
    private onChange(val: any) {
        this.tabList = [];
        this.tabIndex = 0;

        this.tabList = this.typeTabList[val].tabList ? this.typeTabList[val].tabList : [];

        if ( (this as any)['init_' + val] ) {
            (this as any)['init_' + val](val);
        }
       // (this as any)['init_' + val] && (this as any)['init_' + val](val);
    }

    // 还原公交类型的默认参数 回到最初设置
    private init_bus(val: any) {
        this.init_specailAddPath();

        // 公交专用数据
        this.curBusObjData = {
            isCityCross: true, // 是否同城,true 同城
            tabList: this.typeTabList.bus.strategy_incity,
            parentTabList: [],
            curTabItem: this.typeTabList.bus.strategy_incity[0],
            curParentTabItem: this.typeTabList.bus.Trans_type_intercity[0],
            curSamePathObj: {// 同城
                pathResult: [], // 列表数据
                curPathIndex: -1, // 当前点开的详情的数组下标索引,
                curPathIndexForHover: 0, // 因为详情有展开收起状态，但是hover需要一直保持，所以特意写一个标志位，操作当前方案的急活状态。和地图的路线一致
            },
            curCrossPathObj: {
                pathResult: [], // 列表数据
                curPathIndex: 0, // 当前点开的路径方案总览的路线数组下标索引
                curStepIndex: -1, // 当前方案下的第几个step，和curPathIndex结合用来展示详情

            },
        };
    }

    private init_walking(val: any) {
        this.init_specailAddPath();
    }

    private init_riding(val: any) {
        this.init_specailAddPath();
    }

    private init_driving() {
        this.addButtonFlag = true;
        this.addPathNodeNum = this.tempDrivingDatas.length - 2;
        this.pathMainDatas = this.tempDrivingDatas;
    }

    // 因为骑行可以选择途径点，所以在和其它几个进行来回切换的时候，需要将这部分进行处理
    private init_specailAddPath() {
        this.addButtonFlag = false;
        this.addPathNodeNum = 0;

        if (this.pathMainDatas.length > 2) {
            const list = [this.pathMainDatas[0], this.pathMainDatas[this.pathMainDatas.length - 1]];
            this.pathMainDatas = list;
        }
    }


    // ----------搜索路径事件----------------
    /*
    * clickFlag 为true表示，不是从搜索按钮直接点击
    * */
    private toSearchPath(clickFlag: any) {

        /*判断input框的路径输入情况*/
        let goFlag = false;
        let nullFlag = false;
        this.sendPathNodeInfo = [];
        // 判断起始、途径、终点有没有重复的
        const strArr: any[] = [];
        this.pathMainDatas.forEach((item: any) => {
            if (item.inputKey) {
                strArr.push(item.inputKey);
            } else {
                nullFlag = true;
            }
        });
        if (strArr.length > 0) {

            if (new Set(strArr).size !== strArr.length) {
                this.$alert('起始点、途径点、终止点不能重复', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                }).then(() => {

                }).catch(() => {

                });
                return ;
            }
        }

        if (nullFlag) {
            this.$alert('起始点、途径点、终止点不能为空', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
            }).then(() => {

            }).catch(() => {

            });
            return ;
        }


        this.pathMainDatas.forEach((item: any, index: any) => {
            if (!item.isClickOptions) {
           /*     // 输入关键字是否与提示词面板匹配
                let goFlag = true;
                if (this.keywordTipListDatas && this.keywordTipListDatas.baidu && this.keywordTipListDatas.baidu.pois && this.keywordTipListDatas.baidu.pois.length) {
                    this.keywordTipListDatas.baidu.pois.forEach(ele => {
                        if (item.inputKey == ele.name) {
                            this.dealPathMainDatas(item.location, index, true, item.inputKey);
                            debugger
                            goFlag = false;
                        }
                    })

                }

                if (goFlag) {
                    let tempStr = "";
                    if (item.iconClass.includes("startIcon")) {
                        tempStr = "起点"
                    }
                    if (item.iconClass.includes("endIcon")) {
                        tempStr = "终点"
                    }
                    debugger
                    this.$alert(`地址不准确，请选择或输入正确的地址`, '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    }).then(() => {
                        this.dealPathMainDatas(item.location, index, false, item.inputKey);
                    }).catch(() => {

                    });
                }*/
                this.$alert('地址不准确，请选择正确的地址', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                }).then(() => {
                    this.dealPathMainDatas({}, index, false, item.inputKey);
                }).catch(() => {

                });
                goFlag = true;

            }

            if (goFlag) { return; }
            this.sendPathNodeInfo.push(JSON.parse(JSON.stringify({
                lat: item.location.y,
                lon: item.location.x,
                inputKey: item.inputKey,
            })));
        });


        if (!goFlag && !nullFlag) {

            if (!clickFlag) {// 当if为真，代表是从搜索按钮点击进来的，那么要还原默认值
                this.onChange(this.typeIndex);
            }
            this.getPathAnalysisDatas(this.sendPathNodeInfo, this.tabIndex, clickFlag);
        }
    }

    // -----------获取路径规划数据------------------------
    // tabClickFlag 公交时，是从搜索按钮点击还是从其他位置点击，即表示，是否需要还原公交的列表的tab激活项
    private getPathAnalysisDatas(opts: any, tabIndex: any, tabClickFlag: any) {
        if (opts && opts.length > 0) {
            let options;

            options = {
                stops: opts,
               // style: tabIndex
            };
            this.loadingState = true;
            this.errPanel = false;
            (this as any)[this.typeTabList[this.typeIndex].getPathDataFun](options, tabClickFlag);
        }
    }

    private async getData_driving(options: any) {
        const component: any = await this.getComponent();
        const self = this;
        component.queryPath(options)
            .then((res: any) => {
                this.loadingState = false;
                this.doWithPathResultData(res);
            })
            .catch(function(err: any) {
                self.loadingState = false;
                console.error(err);
            });
    }

    private async getData_riding(options: any) {
        const self = this;
        const component: any = await this.getComponent();
        component.queryPath_riding(options)
            .then((res: any) => {
                this.loadingState = false;
                this.doWithPathResultData(res);
            })
            .catch(function(err: any) {
                self.loadingState = false;
                console.error(err);
            });
    }

    private async getData_walking(options: any) {
        const self = this;
        const component: any = await this.getComponent();
        component.queryPath_walking(options)
            .then((res: any) => {
                this.loadingState = false;
                this.doWithPathResultData(res);
            })
            .catch(function(err: any) {
                self.loadingState = false;
                console.error(err);
            });
    }

    private async getData_bus(options: any, tabClickFlag: any) {
        const newOptions = this.getBusNewParamFromOldParam(options, tabClickFlag);
        const self = this;
        const component: any = await this.getComponent();
        component.queryPath_bus(newOptions)
            .then((res: any) => {
                this.doWithPathResultData_bus(res, tabClickFlag);
            })
            .catch(function(err: any) {
                self.doWithResponeErr(err, null);
            });
    }

    // 对查询路线数据时，返回的res.error进行统一处理
    // err，是错误信息或者true
    // routeNullFlag,代表返回来的路线数据为空数组等，暂时用不到，预留
    private doWithResponeErr(err: any, routeNullFlag: any) {
        this.loadingState = false;
        if (err) {
            // jQuery('.pathAnalysisWrap').css('display', 'none');
            this.isShowPathAlsTabBusItem = false;
            this.errPanel = true;
            return true;
        }
        this.errPanel = false;
        return false;
    }

    // 将从通用接口获得的起点终点的数组的options进行重组，以适用公交
    // tabClickFlag 不为true时，表示从搜索按钮点击过来的。要把参数还原到走默认参数
    private getBusNewParamFromOldParam(options: any, tabClickFlag: any) {
        const newOptions: any = {};
        newOptions.stops = options.stops;
        // 对同城和跨城分别进行参数处理
        const crossFlag = this.curBusObjData.isCityCross; // true代码同城

        // if(!tabClickFlag){//参数还原
        //     this.init_bus();
        // }

        if (crossFlag) {

            newOptions.strategy_incity = this.curBusObjData.curTabItem.value;
        } else {
            newOptions.strategy_intercity = this.curBusObjData.curTabItem.value;
            newOptions.Trans_type_intercity = this.curBusObjData.curParentTabItem.value;
        }
        return newOptions;
    }

    private doWithPathResultData(res: any) {
        if (!this.doWithResponeErr(res.error, null)) {// res.error为false的时候，执行
            // jQuery('.pathAnalysisWrap').css('display', 'block');
            this.isShowPathAlsTabBusItem = true;
            this.pathanalysislist = res.road;
            this.resultLength = res.length;
        }
    }
    /**
     * 在非公交的面板种的分项点击事件
     * */
    private  async  toSinglePathNode(item: any) {
        const component: any = await this.getComponent();
        component.showSingleRoad(item);
    }

    /**
     * tabClickFlag 为true 表示从路径面板的切换按钮点过来的
     * */
    private doWithPathResultData_bus(res: any, tabClickFlag: any) {

        if (this.doWithResponeErr(res.error, null)) {
            return;
        }


        if (this.doWithResponeErr(((!res.routes) || (!res.routes.length)), true)) {
            return;
        }
        this.isShowPathAlsTabBusItem = true;
        // jQuery('.pathAnalysisWrap').css('display', 'block');

        const crossFlag = res.destination.city_name === res.origin.city_name;
        const tabList = crossFlag ? this.typeTabList.bus.strategy_incity : this.typeTabList.bus.strategy_intercity;
        const parentTabList = crossFlag ? [] : this.typeTabList.bus.Trans_type_intercity;
        this.curBusObjData.isCityCross = crossFlag; // 是否同城
        this.curBusObjData.tabList = tabList;
        this.curBusObjData.parentTabList = parentTabList;
        this.curBusObjData.curTabItem = tabClickFlag ? this.curBusObjData.curTabItem : tabList[0];
        this.curBusObjData.curParentTabItem = (parentTabList.length && tabClickFlag) ? this.curBusObjData.curParentTabItem : parentTabList[0];

        // routes distance duration price
        // steps [] schemes[] instruction

        if (crossFlag) {
            this.getSameCityObj(res);
        } else {
            this.getCrossCityObj(res);
        }


    }

    /*得到同城的路径*/
    private getSameCityObj(res: any) {

        const resultArr: any[] = [];


        res.routes.forEach((item: any, index: any) => {
            const obj: any = {};
            const busArr: any[] = [];
            let walkDis = 0;
            obj.distance = item.distance;
            obj.duration = item.duration;
            obj.price = item.price;
            obj.steps = item.steps;
            obj.price_detail = item.price_detail;
            obj.realSteps = [];

            item.steps.forEach((sitem: any, sindex: any) => {
                const stepsItem = {
                    schemes: [],
                };
                sitem.schemes.forEach((ssitem: any, ssindex: any) => {
                    if (ssitem.vehicle_info.type === 5) {
                        walkDis += ssitem.distance;
                    }
                    if (ssitem.vehicle_info.type !== 5) {
                        busArr.push(ssitem.vehicle_info.detail.name);
                    }
                });
            });
            obj.busArr = busArr;
            obj.walkDis = walkDis;
            resultArr.push(obj);
        });

        this.curBusObjData.curSamePathObj.pathResult = resultArr;
        this.curBusObjData.curSamePathObj.curPathIndex = -1;
        this.curBusObjData.curSamePathObj.curPathIndexForHover = 0;

    }

    /*得到跨城路径*/
    private getCrossCityObj(res: any) {

        const stepOverviewArr = [];
        res.routes.forEach((ritem: any, rindex: any) => {
            ritem.steps.forEach((rsitem: any, rsindex: any) => {
                if (rsindex === 0) {// step 0
                    const stepOverviewObj = {
                        start_location: this.pathMainDatas[0].address,
                        // 本step的终点，当最后一个schemes的vehicle_info.detail有值，那么就是非步行，则取arrive_station或者off_station（公交和其它交通工具不一样）
                        //
                        end_location: rsitem.schemes[rsitem.schemes.length - 1].vehicle_info.detail
                            ?
                            (rsitem.schemes[rsitem.schemes.length - 1].vehicle_info.detail.arrive_station || rsitem.schemes[rsitem.schemes.length - 1].vehicle_info.detail.on_station)
                            :
                            (ritem.steps[1].schemes[0].vehicle_info.detail.departure_station || ritem.steps[1].schemes[0].vehicle_info.detail.off_station),
                        duration: 0,
                    };
                    rsitem.schemes.forEach((rssitem: any, rssindex: any) => {
                        stepOverviewObj.duration += rssitem.duration;
                    });
                    rsitem.stepOverviewObj = stepOverviewObj;
                } else if (rsindex === (ritem.steps.length - 1)) {
                    const stepOverviewObj2 = {
                        // 先从本step的schemes[0]的detail中拿值，如果是步行，则从上一个step的最后一个scheme拿值
                        start_location: rsitem.schemes[0].vehicle_info.detail
                            ?
                            (rsitem.schemes[0].vehicle_info.detail.arrive_station || rsitem.schemes[0].vehicle_info.detail.arrive_station)
                            :
                            (ritem.steps[ritem.steps.length - 2].schemes[ritem.steps[ritem.steps.length - 2].schemes.length - 1].vehicle_info.detail.arrive_station || ritem.steps[ritem.steps.length - 2].schemes[ritem.steps[ritem.steps.length - 2].schemes.length - 1].vehicle_info.detail.on_station),
                        end_location: this.pathMainDatas[this.pathMainDatas.length - 1].address,
                        duration: 0,
                    };
                    rsitem.schemes.forEach((rssitem: any, rssindex: any) => {
                        stepOverviewObj2.duration += rssitem.duration;
                    });
                    rsitem.stepOverviewObj = stepOverviewObj2;
                } else {
                    const stepOverviewObj3 = {
                        start_location: rsitem.schemes[0].vehicle_info.detail
                            ?
                            (rsitem.schemes[0].vehicle_info.detail.departure_station || rsitem.schemes[0].vehicle_info.detail.off_station)
                            :
                            (ritem.steps[rsindex - 1].schemes[ritem.steps[rsindex - 1].schemes.length - 1].vehicle_info.detail.arrive_station || ritem.steps[rsindex - 1].schemes[ritem.steps[rsindex - 1].schemes.length - 1].vehicle_info.detail.on_station),
                        end_location: rsitem.schemes[rsitem.schemes.length - 1].vehicle_info.detail
                            ?
                            (rsitem.schemes[rsitem.schemes.length - 1].vehicle_info.detail.arrive_station || rsitem.schemes[rsitem.schemes.length - 1].vehicle_info.detail.on_station)
                            :
                            (ritem.steps[rsindex + 1].schemes[0].vehicle_info.detail.off_station || ritem.steps[rsindex + 1].schemes[0].vehicle_info.detail.departure_station),
                        duration: 0,
                    };
                    rsitem.schemes.forEach((rssitem: any, rssindex: any) => {
                        stepOverviewObj3.duration += rssitem.duration;
                    });
                    rsitem.stepOverviewObj = stepOverviewObj3;
                }

            });
        });
        this.curBusObjData.curCrossPathObj.pathResult = res.routes;
        this.curBusObjData.curCrossPathObj.curPathIndex = 0;
    }

    /**
     * 点击公交的tab
     */
    private toBusTabItemClick(item: any, index: any) {
        if (this.curBusObjData.curTabItem.value === item.value) {
            return;
        }
        this.curBusObjData.curTabItem = item;
        this.toSearchPath(true);

    }


    /**
     * 点击同城结果面板的总览item
     * */
    private async clickSameCityOverviewItem(item: any, index: any) {
        if (this.curBusObjData.curSamePathObj.curPathIndex === index) {
            this.curBusObjData.curSamePathObj.curPathIndex = -1;
            this.curBusObjData.curSamePathObj.curPathIndexForHover = index; // 即使详情关闭了，但是hover的样式还是要的
            return;
        }
        this.curBusObjData.curSamePathObj.curPathIndex = index;
        const component: any = await this.getComponent();
        component.showBusRoute(item.steps);
        this.curBusObjData.curSamePathObj.curPathIndexForHover = index; // 即使详情关闭了，但是hover的样式还是要的
    }

    /**
     * 点击跨城方案总览的item
     * */
    private async clickRouteItemOverview(item: any, index: any) {
        if (this.curBusObjData.curCrossPathObj.curPathIndex === index) {
            this.curBusObjData.curCrossPathObj.curPathIndex = -1;
            return;
        }
        const component: any = await this.getComponent();
        component.showBusRoute(item.steps);
        this.curBusObjData.curCrossPathObj.curPathIndex = index;
    }

    /**
     * 点击当前展开的方案下，step的详情 Span 文字详情，只展示前端面板
     * */
    private clickStepItemSpan(stepsItem: any, stepsIndex: any) {
        if (this.curBusObjData.curCrossPathObj.curStepIndex === stepsIndex) {
            this.curBusObjData.curCrossPathObj.curStepIndex = -1;
            return;
        }
        /*const component: any = await this.getComponent();
        component.showBusRouteSchemes(stepsItem.schemes);*/
        this.curBusObjData.curCrossPathObj.curStepIndex = stepsIndex;
    }

    /**
     * 点击当前展开的方案下，step的详情 地图的事件
     * */
    private async clickStepItemDiv(stepsItem: any, stepsIndex: any) {
        if (this.curBusObjData.curCrossPathObj.curStepIndex === stepsIndex) {
            this.curBusObjData.curCrossPathObj.curStepIndex = -1;
            return;
        }
        const component: any = await this.getComponent();
        component.showBusRouteSchemes(stepsItem.schemes);
        this.curBusObjData.curCrossPathObj.curStepIndex = stepsIndex;
    }

    /**
     * 在特定数组中找到某个属性值，并返回索引
     */
    private findTarget(val: any, arr: any, paramKey: any) {
        return arr.findIndex((item: any, index: any) => {
            return item.paramKey === val;
        });
    }


    /**
     * 切换跨城 tab 火车 飞机的那个
     * */
    private clickCrossTypeTabItem(item: any, index: any) {
        if (this.curBusObjData.curParentTabItem.value === item.value) {
            return;
        }
        this.curBusObjData.curParentTabItem = jQuery.extend(true, {}, item);
        const tabList = this.curBusObjData.isCityCross ? this.typeTabList.bus.strategy_incity : this.typeTabList.bus.strategy_intercity;
        this.curBusObjData.curTabItem = tabList[0];

        // true 表示不是从搜索按钮点击的
        this.toSearchPath(true);
        // this.getPathAnalysisDatas(this.sendPathNodeInfo, this.tabIndex, true);//这个tabindex参数在公交查询中没什么实质作用，
    }

    /**
     * 点击scheme的那个详情
     * */
    private async clikSchemesItem(schemesItem: any, schemesIndex: any) {
        const component: any = await this.getComponent();
        component.highlightBusRouteScheme(schemesItem.path);
    }


    // -----------获取骑行规划数据------------------------
    private async getPathAnalysisDatas_riding(opts: any, tabIndex: any) {
        const options = {
            stops: opts,
            style: tabIndex,
        };
        const component: any = await this.getComponent();
        component.queryPath(options)
            .then((res: any) => {
                this.pathanalysislist = res.road;
                this.resultLength = res.length;
            })
            .catch(function(err: any) {
                console.error(err);
            });
    }

    // ---------选中路径节点与地图交事件------------
    private async getSinglePathNode(opt: any, index: any) {
        opt.position = index;
        const component: any = await this.getComponent();
        component.addPoint(opt);
        // console.log("single",opt,index)
    }

    // --------修改节点数据---------
    private dealPathMainDatas(location: any, index: any, flag: any, inputKey: any) {
        this.pathMainDatas[index].inputKey = inputKey;
        this.pathMainDatas[index].location = location;
        this.pathMainDatas[index].isClickOptions = flag;
    }

    /**
     * 输入框点击监听，开启绘制点事件
     * @param item
     * @param index
     */
    private inputClick(item: any, index: any) {
        // item.position = index;
       /// this.getComponent().startSelectPoint(item);
    }

    // ---------input监听事件-----------------
    private async inputWatch(item: any, index: any) {
        this.currentIndex = index;
        if (item.inputKey) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.getListPOI(item.inputKey);
            }, 300);
        } else {
            this.isShowPathTip = false;

            item.position = index;
            const component: any = await this.getComponent();
            component.removePoint(item);
            let tempNum = 0;
            this.pathMainDatas.map((ele: any, idx: any) => {
                if (!ele.inputKey) {
                    this.dealPathMainDatas({}, idx, false, '');
                    tempNum++;
                }
            });

            if (tempNum === this.pathMainDatas.length) {
                // jQuery('.pathAnalysisWrap').fadeOut();
                this.isShowPathAlsTabBusItem = false;
            }
        }

    }

    private pathTipItemClick(val: any) {
        if (typeof val === 'string') {
            this.dealPathMainDatas('', this.currentIndex, false, val);
            return ;
        }
        this.dealPathMainDatas(val.location, this.currentIndex, true, val.name);
        this.pathMainDatas[this.currentIndex].inputKey = val.name;
        this.isShowPathTip = false;
        // 选中路径节点与地图交事件
        this.getSinglePathNode(this.pathMainDatas[this.currentIndex], this.currentIndex);

    }


    // -------路径内部icon添加、删除事件-----------
    private async handleIconClick(item: any , index: any) {
        if (item.clickClass === 'el-icon-circle-plus') {

            if (this.addPathNodeNum === 5) { return; }
            this.addPathNodeNum++;

            this.pathMainDatas.splice(this.pathMainDatas.length - 1, 0,
                {
                    iconClass: 'preIcon stopIcon',
                    clickClass: 'el-icon-remove',
                    placeholder: '请输入途经点',
                    inputKey: '',
                    isClickOptions: false,
                });
        }
        if (item.clickClass === 'el-icon-remove') {

            if (this.pathMainDatas[index].isClickOptions) {
                console.log(item, index);
            }
            this.pathMainDatas.splice(index, 1);
            this.addPathNodeNum--;
            const component: any = await this.getComponent();
            component.removePoint(item);
        }

        // 保存途径点的变量
        this.tempDrivingDatas = this.pathMainDatas;

    }

    // -------点击路径节点前面的图标--------
    private async  toClickPreIcon(item: any , index: any ) {
        item.position = index;
        const component: any = await this.getComponent();
        component.startSelectPoint(item);
    }

    // ---------路径节点翻事件--------------
    private async toReverse() {
        let tempFlag = true; // 默认pathMainDatas这个数组的inputkey都有值
        this.pathMainDatas.forEach((item: any) => {
            if (!item.inputKey) {// 只要有一个没有值，就认为没有值
                tempFlag = false;
            }
        });

        if (!tempFlag) {
            this.$alert('请至少输入一个起点或终点', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
            }).catch(() => {
            });
            return ;
        }

        this.pathMainDatas.reverse(); // 翻转input框
        this.pathMainDatas[0].iconClass = 'preIcon startIcon';
        this.pathMainDatas[0].clickClass = 'el-icon-circle-plus';
        this.pathMainDatas[this.pathMainDatas.length - 1].iconClass = 'preIcon endIcon';
        this.pathMainDatas[this.pathMainDatas.length - 1].clickClass = '';
        const component: any = await  this.getComponent();
        component.reversePoints(this.pathMainDatas);

        // 发请求
        // 这个tabindex参数在公交查询中没什么实质作用，true表示，不是点击那个放大镜的搜索按钮，取当前的参数
        // this.getPathAnalysisDatas(this.sendPathNodeInfo, this.tabIndex, true);
        this.toSearchPath(true);

    }


    // ----------tab切换事件----------------
    private toTabItemClick(item: any , index: any ) {
        this.tabIndex = index;
        // this.getPathAnalysisDatas(this.sendPathNodeInfo, this.tabIndex)
        this.toSearchPath(true);
    }


    private async initMapEvents() {
        const self = this;
        // 接收地图选点数据
        const component: any = await this.getComponent();

        component.off('dealPathMainDatas');
        component.on('dealPathMainDatas', function(val: any) {
            self.dealPathMainDatas(val.location, val.position, true, val.address);
        });
    }

    private created() {
        this.initMapEvents();
        // 保存途径点的变量
        this.tempDrivingDatas = this.pathMainDatas;
    }

    private getComponent(moduleName: string = 'RoutePlan', componentName: string = 'routePlanning') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
    }
}
